import React from "react";
import Layout from "@/components/layout";
import HeaderOne from "@/components/header-one";
import MenuContextProvider from "@/context/menu-context";
import PageHeader from "@/components/page-header";
import Footer from "@/components/footer";
import AboutFour from "@/components/about-four";
import VideoOne from "@/components/video-one";
import AboutTwo from "@/components/about-two";

const About = () => {
  return (
    <MenuContextProvider>
      <Layout PageTitle="About - Rouge Multiservice">
        <HeaderOne />
        <PageHeader title="Rouge Multiservice" name="About" />
        <AboutFour />
        <VideoOne />
        <AboutTwo />
        <Footer />
      </Layout>
    </MenuContextProvider>
  );
};

export default About;
